import React from "react";

const PaymentAgreementIcon = (props: any) => {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M17.5 5.835v8.333c0 2.5-1.25 4.167-4.167 4.167H6.667c-2.917 0-4.167-1.667-4.167-4.167V5.835c0-2.5 1.25-4.167 4.167-4.167h6.666c2.917 0 4.167 1.667 4.167 4.167Z"
      />
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M12.084 3.75v1.667c0 .916.75 1.666 1.666 1.666h1.667M6.667 10.832H10M6.667 14.168h6.666"
      />
    </svg>
  );
};

export default PaymentAgreementIcon;
